import { Box, Flex } from '@chakra-ui/react';
import type { ReactNode } from 'react';

interface InfoBannerProps {
  color: string;
  bg: string;
  icon: ReactNode;
  children: ReactNode;
  mt?: string | number;
  py?: string | number;
  borderRadius?: string;
  hasLeftBorder?: boolean;
}

const InfoBanner = ({
  color,
  bg,
  icon,
  children,
  mt = 4,
  py = 3,
  borderRadius = '0px',
  hasLeftBorder = true,
}: InfoBannerProps) => (
  <Box
    bg={bg}
    w="full"
    mt={mt}
    py={py}
    px={4}
    borderLeft={hasLeftBorder ? `10px solid ${color}` : 'none'}
    borderRadius={borderRadius}
  >
    <Flex direction="row" gap={3} alignItems="center">
      {icon}
      <Flex direction="column" gap={0.5}>
        {children}
      </Flex>
    </Flex>
  </Box>
);

export default InfoBanner;
